<template>
    <label v-if="label" for="label">{{ label }}</label>
    <div class="p-inputgroup">
        <Dropdown v-if="type == types.DROP_DOWN" v-model="optionModel" :options="options" optionLabel="label" :placeholder="placeholder" showClear />
        <MultiSelect v-else v-model="optionModel" :options="options" display="chip" optionLabel="label" :placeholder="placeholder" showClear />
    </div>
</template>

<script>
export default {
    name: 'DropdownInput',
    props: {
        label: {
            type: String,
        },
        type: {
            type: String,
        },
        types: {
            type: [Array, Object],
        },
        placeholder: {
            type: String,
        },
        attributeOptions: {
            type: Array,
        },
    },
    data() {
        return {
            options: [],
            optionModel: null,
        };
    },
    created() {
        this.options = this.attributeOptions;
    },
};
</script>

<style scoped>
label {
    max-width: 100%;
    display: inline-block;
    overflow-wrap: break-word;
}
</style>
